export default "__VITE_ASSET__1rmiyk0e__"